import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const opts = {
    theme: {
        themes: {
            light: {
                primary: '#f96332',
                secondary: '#3F51B5',
                accent: colors.blue.lighten3,
            },
        },
    },
}

export default new Vuetify(opts)